import { BottomBannerButton } from "features/qualityForm/formEditor/BottomBannerButtons";
import {
    NewRelicActionName,
    NewRelicCustomAttributeName,
} from "../NewRelicEnum";
import newRelicService from "../newRelicService";

export function addNewRelicPageActionForBottomBannerButtonClick(
    bannerButton: BottomBannerButton
) {
    newRelicService.addPageAction(
        NewRelicActionName.INTERACTION_BUTTON_CLICKED,
        { interactionButton: bannerButton }
    );
}

export function addNewRelicPageActionForSavingForm(isSuccessful: boolean) {
    newRelicService.addPageAction(
        isSuccessful
            ? NewRelicActionName.INTERACTION_SAVING_FORM_SUCCEEDED
            : NewRelicActionName.INTERACTION_SAVING_FORM_FAILED
    );
}

export function setNewRelicCustomAttributeForCopyFeature(
    isInCopyingViewMode: boolean
) {
    newRelicService.setCustomAttribute(
        NewRelicCustomAttributeName.IS_COPIED_FORM,
        isInCopyingViewMode.toString()
    );
}
